module.exports = __webpack_public_path__ + "static/media/story-18.29199c7c.jpg";